<template lang="pug">
.relative(
  :class="{ 'full-width': filesForRenaming.length }"
)
  template(v-if="!filesForRenaming.length")
    drag-and-drop.px-0.py-0.rounded-16.fit-height(
      :accept="accept"
      :multiple="multiple"
      :uploadHandler="uploadHandler"
      :maxSize="maxSize"
      @uploaded="uploaded"
    )
      template(#uploading-button): span
      template(#main="{ pickFile }")
        slot(name="field" v-bind="{ pickFile }")
          .redesign-border.pointer.py-4.text-center.full-width(
            @click="pickFile"
          )
            v-icon.mt-2(
              color="redesignPrimary"
              :size="44"
            ) $iupload-cloud
            p.user-select-none.mt-4.body-1.px-4 {{ mainText }}
        slot(
          name="action"
          v-bind="{ pickFile, showIcon: !hideActionBtnIcon, icon: actionBtnIcon, title: actionTitle }"
        )
          v-btn.subtitle-1.mt-4.pa-0.align-self-start.ml-1(
            color="transparent"
            :opacity="1"
            text
            @click="pickFile"
          )
            template(v-if="!hideActionBtnIcon")
              v-icon(
                color="redesignPrimaryDarken"
                :size="22"
                left
              ) {{ actionBtnIcon }}
            span.redesignPrimaryDarken--text {{ actionTitle }}
      template(#uploading="{ progress }")
        slot(
          name="uploading"
          v-bind="{ progress }"
        )
          .redesign-border.rounded-16.py-4.px-8.text-center.full-width
            v-icon.mt-2(
              color="redesignYellowDarken"
              :size="42"
            ) $iclock-outline
            p.user-select-none.my-4.body-1.text-capitalize {{ fileText }} загружается...
            v-progress-linear(
              color="redesignPrimaryDarken"
              :value="progress"
              rounded
            )
      template(#uploaded): span

  template(v-else-if="fileForRenaming")
    validation-observer(
      tag="div"
      v-slot="{ invalid }"
    )
      slot(
        name="rename-container"
        v-bind="{ fileForRenaming, nextRenamingFile, invalid }"
      )
        .d-flex.full-width.full-height.flex-column.justify-center.gap-32.align-center.pa-4
          v-img(
            :src="fileForRenaming.rename.image"
            :max-width="48"
          )
          valid-text-area.d-block.px-12.full-width(
            v-model="fileForRenaming.rename.name"
            name="Название файла"
            placeholder="Введите название файла"
            :rows="1"
            :max-symbols="64"
            :min-symbols="1"
            outlined
          )
          app-button.px-7.rounded-12.white--text.ma-0.body-1(
            color="redesignPrimary"
            :width="250"
            :disabled="invalid"
            large
            @click="nextRenamingFile"
          ) Сохранить название
</template>

<script>
import DragAndDrop from '@/components/inputs/DragAndDrop.vue';
import ValidTextArea from '@/modules/UserEventLanding/components/event-landing/program/participation-stage/ValidationTextArea.vue';
import PDFImage from '@/assets/redesign/file-pdf.svg';
import DOCImage from '@/assets/redesign/file-doc.svg';
import { readURL } from '@/helpers/files';
import { EXTENSIONS } from '@/constants/filesExtensions';

export default {
  name: 'AppDragAndDrop',
  components: {
    DragAndDrop,
    ValidTextArea,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    accept: {
      type: String,
      default: EXTENSIONS.images.accept,
    },
    // mb
    maxSize: {
      type: Number,
      default: 5,
    },
    uploadHandler: {
      type: Function,
      default: readURL,
    },
    rename: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    hideActionBtnIcon: {
      type: Boolean,
      default: false,
    },
    actionBtnIcon: {
      type: String,
      default: '$iplus-outline',
    },
    actionBtnTitle: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      filesForRenaming: [],
      savedRenamingFiles: [],
    };
  },

  computed: {
    // REFACTOR: plural
    fileText() {
      return `файл${this.multiple ? 'ы' : ''}`;
    },
    mainText() {
      return this.text || `Перенесите ${this.fileText} в это поле или загрузите с устройства`;
    },
    actionTitle() {
      return this.actionBtnTitle || `Загрузить ${this.fileText}`;
    },
    fileForRenaming() {
      const [file] = this.filesForRenaming;
      if (!file?.rename) return null;
      return file;
    },
  },
  methods: {
    uploaded(files) {
      if (!this.rename) {
        this.$emit('uploaded', files);
        return;
      }
      this.savedRenamingFiles = [];
      this.filesForRenaming = files.map((file) => {
        const fileName = file.name || file.file.name;
        const extension = fileName.match(/\.[^.]*$/)[0];
        const name = fileName.replace(extension, '');

        return {
          ...file,
          rename: {
            name,
            extension,
            image: extension === '.pdf' ? PDFImage : DOCImage,
          },
        };
      });
    },
    nextRenamingFile() {
      const file = { ...this.filesForRenaming.shift() };
      const newName = file.rename.name + file.rename.extension;
      file.rename = newName;
      this.savedRenamingFiles.push(file);
      if (!this.filesForRenaming.length) {
        this.$emit('uploaded', this.savedRenamingFiles);
        this.savedRenamingFiles = [];
      }
    },
  },
};
</script>
